<div class="ctl-search-area">
        <div class="content" *ngIf="gridControlsList$ | async as gridControlsListItem">
            <div class="first-table-container">
            <dk-dx-data-table2
            class="px-7"
            [dataSource]="data"
            [columnList]="columns"
            height="100%"
            [columnTransactions]="false"
            [gridCtlList]="gridControlsListItem"
            (focusedRowChanged)="focusChanged($event)"
            [dontSelectDataSource]="true"
        [isGroupingYn]="false"
        [focusSearchBar]="true"
        (keyDown)="onKeyDown($event)"
        (rowDblClick)="dblClickRow($event)"
            >
            </dk-dx-data-table2>
            </div>
        </div>
        
        <div class="search-btn-area">
            <div>
                <dx-button
                    icon="check"
                    stylingMode="contained"
                    text="Seç"
                    type="success"
                    [width]="150"
                    (onClick)="chooseBtnClick()">
                </dx-button>
            </div>
            <div class="search-right-btn">
                <dx-button
                    icon="close"
                    stylingMode="contained"
                    text="İptal"
                    type="danger"
                    [width]="150"
                    (onClick)="cancelBtnClick()">
                </dx-button>
            </div>
        </div>
    </div>
